<template>
  <v-row>
    <v-alert
      :type="type"
      dismissible
      :value="message != null && message !== ''"
    >
      {{ message }}
      <slot />
    </v-alert>
  </v-row>
</template>

<script>
export default {
  name: 'exo-alert-panel',
  props: {
    exception: Object | String,
    gravity: String
  },

  data() {
    return {
      message: this.exception,
      type: this.gravity
    }
  }
}
</script>

<style scoped></style>
